import React, { useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import Container from "react-bootstrap/Container";
import sections from "../../data/sections";
import { Close, ArrowForward } from "@mui/icons-material";

import "./NavbarOverview.css";
// const sectionsIcons = {
//   home: <Home />,
//   about: <Person />,
//   services: <Work />,
//   contact: <Email />,
// };

interface Section {
  id: string;
  title: string;
  description: string;
  fullDescription: string;
  background: string;
  image: string;
}

const NavbarOverview = () => {
  const [open, setOpen] = useState(false);
  const [selectedSection, setSelectedSection] = useState<Section | null>(null);

  interface HandleOpen {
    (section: Section): void;
  }

  const handleOpen: HandleOpen = (section) => {
    setSelectedSection(section);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedSection(null);
  };

  return (
    <section id="navbar-overview" className="navbar-overview-section">
      <Container>
        <Box sx={{ textAlign: "center", mb: 7 }}>
          <span className="luxe-eyebrow">Cabinet ZEVA</span>
          <Typography
            variant="h3"
            className="luxe-heading"
            sx={{ fontWeight: 700, mb: 2, letterSpacing: "-0.02em" }}
          >
            Découvrez notre univers
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "var(--luxe-muted)",
              maxWidth: "600px",
              margin: "0 auto",
              fontSize: "1.1rem",
              lineHeight: 1.7,
              fontWeight: 300,
            }}
          >
            Explorez mes différents services et découvrez comment je peux vous
            accompagner dans votre parcours.
          </Typography>
        </Box>
        <Grid container spacing={4} justifyContent="center">
          {sections.map((section, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card
                onClick={() => handleOpen(section)}
                sx={{
                  textAlign: "center",
                  transition: "all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                  borderRadius: "18px",
                  boxShadow: "0 14px 36px rgba(26, 23, 18, 0.18)",
                  background: section.background,
                  color: "white",
                  cursor: "pointer",
                  height: "290px",
                  display: "flex",
                  flexDirection: "column",
                  position: "relative",
                  overflow: "hidden",
                  border: "1px solid rgba(201, 169, 106, 0.35)",
                  "&:hover": {
                    transform: "translateY(-10px) scale(1.02)",
                    boxShadow: "0 28px 60px rgba(26, 23, 18, 0.32)",
                    borderColor: "rgba(201, 169, 106, 0.7)",
                  },
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "2px",
                    background:
                      "linear-gradient(135deg, #a8894f, #c9a96a 55%, #e2cb9a)",
                    pointerEvents: "none",
                  },
                }}
              >
                <CardContent
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    padding: "24px",
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  <Box
                    sx={{
                      mb: 3,
                      "& svg": {
                        fontSize: "2.8rem",
                        filter: "drop-shadow(0 2px 6px rgba(0,0,0,0.35))",
                        color: "var(--luxe-gold)",
                      },
                    }}
                  >
                    {section.icon}
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      mb: 1.5,
                      fontFamily: "var(--font-display)",
                      fontWeight: 600,
                      letterSpacing: "0.02em",
                      color: "#fff",
                    }}
                  >
                    {section.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      lineHeight: 1.65,
                      fontSize: "0.9rem",
                      fontWeight: 300,
                      color: "rgba(245, 241, 232, 0.82)",
                    }}
                  >
                    {section.description}
                  </Typography>
                  <span className="card-cta">
                    Cliquez pour en savoir plus
                    <ArrowForward sx={{ fontSize: "1rem !important" }} />
                  </span>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* --- MODALE --- */}
        <Dialog
          open={open}
          onClose={handleClose}
          maxWidth="md"
          fullWidth
          slotProps={{
            paper: {
              sx: {
                borderRadius: "18px",
                background:
                  "linear-gradient(160deg, #ffffff 0%, var(--luxe-ivory) 100%)",
                border: "1px solid rgba(201, 169, 106, 0.35)",
                boxShadow: "0 40px 90px rgba(26, 23, 18, 0.35)",
              },
            },
          }}
        >
          {selectedSection && (
            <>
              <DialogTitle
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontFamily: "var(--font-display)",
                  fontWeight: 600,
                  fontSize: "1.75rem",
                  color: "var(--luxe-ink)",
                  borderBottom: "1px solid rgba(201, 169, 106, 0.3)",
                }}
              >
                {selectedSection.title}
                <IconButton onClick={handleClose} sx={{ color: "var(--luxe-gold-deep)" }}>
                  <Close />
                </IconButton>
              </DialogTitle>
              <DialogContent className="zeva-modal-content">
                <div className="zeva-modal-body">
                  <div className="zeva-modal-media">
                    <img
                      src={selectedSection.image}
                      alt={selectedSection.title}
                    />
                  </div>
                  <div
                    className="zeva-modal-richtext"
                    dangerouslySetInnerHTML={{
                      __html: selectedSection.fullDescription,
                    }}
                  />
                </div>
              </DialogContent>
            </>
          )}
        </Dialog>
      </Container>
    </section>
  );
};

export default NavbarOverview;
